import React from 'react';
import styled from 'styled-components';
import { Avatar } from 'antd';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { BASE } from 'api';

const Wrapper = styled.div`
  &&& {
    position: relative;
    margin-bottom: 10px;
    .avatar {
      margin-right: 10px;
    }
    .name {
      display: flex;
      width: max-content;
      align-items: center;
      justify-content: center;
      margin-bottom: 9px;
      color: #333333;
    }
    .cloud {
      padding: 15px;
      border-radius: 12px;
      width: max-content;
      max-width: 650px;
      .text {
        padding: 15px;
      }
    }
    .date {
      font-size: 10px;
      color: #777777;
      opacity: 0.5;
      margin-left: 11px;
      padding-top: 4px;
    }
  }
`;

function Message({ client, text, date, manager, avatar }) {
  const { t } = useTranslation();
  return (
    <Wrapper>
      <div className="name">
        <div className="avatar">
          {avatar ? (
            !manager ? (
              client.avatar === null || client.avatar === '' ? (
                <Avatar className="h-20 w-20 flex items-center">
                  {client.first_name[0]}
                </Avatar>
              ) : (
                <Avatar
                  className="h-20 w-20 flex items-center"
                  src={`${BASE}${client.avatar}`}
                />
              )
            ) : manager.avatar ? (
              <Avatar
                className="h-20 w-20 flex items-center"
                src={`${BASE}${manager.avatar}`}
              />
            ) : (
              <Avatar className="h-20 w-20 flex items-center">
                {manager.first_name[0]}
              </Avatar>
            )
          ) : null}
        </div>
        {avatar && (
          <>
            <div className="mr-5">
              {!manager ? client.first_name : manager.first_name}{' '}
            </div>
            <div>{!manager ? client.last_name : manager.last_name}</div>
          </>
        )}

        {date && (
          <div className="date">
            {moment().subtract(1, 'days').format('DD.MM.YYYY') ===
            moment(date).format('DD.MM.YYYY')
              ? `${t('yesterday')} ${moment(date)
                  .subtract(new Date(date).getTimezoneOffset(), 'minutes')
                  .format('HH:mm')}`
              : moment().format('DD.MM.YYYY') ===
                moment(date).format('DD.MM.YYYY')
              ? `${t('today')} ${moment(date)
                  .subtract(new Date(date).getTimezoneOffset(), 'minutes')
                  .format('HH:mm')}`
              : moment(date)
                  .subtract(new Date(date).getTimezoneOffset(), 'minutes')
                  .format('DD.MM.YYYY HH:mm')}
          </div>
        )}
      </div>
      <div
        className={
          manager ? `ml-30 cloud bg-primary` : `ml-30 cloud bg-clientMessage`
        }
      >
        <div className={manager ? `text-white` : 'text-black'}>{text}</div>
      </div>
    </Wrapper>
  );
}

export default Message;
